import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export interface AxeViolation {
  id: string;
  impact: string;
  description: string;
  nodes: number;
}

export function A11yBar({ violations }: { violations: AxeViolation[] }) {
  const buckets = ['critical', 'serious', 'moderate', 'minor'] as const;
  const data = buckets.map((b) => ({
    impact: b,
    count: violations.filter((v) => v.impact === b).length,
    nodes: violations.filter((v) => v.impact === b).reduce((sum, v) => sum + (v.nodes ?? 0), 0),
  }));
  const colorByImpact: Record<string, string> = {
    critical: 'oklch(0.55 0.20 27)',
    serious: 'oklch(0.65 0.18 50)',
    moderate: 'oklch(0.75 0.15 80)',
    minor: 'oklch(0.65 0.05 250)',
  };
  if (violations.length === 0) {
    return (
      <p className="rounded border border-emerald-500/30 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-300">
        ✅ No axe-core violations detected.
      </p>
    );
  }
  return (
    <ResponsiveContainer width="100%" height={220}>
      <BarChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: -16 }}>
        <CartesianGrid stroke="oklch(0.30 0.02 250)" strokeDasharray="3 3" />
        <XAxis dataKey="impact" tick={{ fill: 'oklch(0.65 0.02 250)', fontSize: 11 }} />
        <YAxis allowDecimals={false} tick={{ fill: 'oklch(0.65 0.02 250)', fontSize: 11 }} />
        <Tooltip
          contentStyle={{
            background: 'oklch(0.20 0.02 250)',
            border: '1px solid oklch(0.30 0.02 250)',
            borderRadius: 6,
            fontSize: 12,
          }}
          formatter={(value, name) => [`${value} ${name === 'count' ? 'rules' : 'nodes'}`, '']}
        />
        <Bar dataKey="count" radius={[4, 4, 0, 0]}>
          {data.map((d) => (
            <rect key={d.impact} fill={colorByImpact[d.impact]} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
